(() => {
  'use strict';

  const init = () => {
    const grid = document.querySelector('.pax-collection-product-grid');
    const pagination = document.querySelector('[data-pax-infinite-pagination]');
    if (!grid || !pagination) return;

    const nextLink = pagination.querySelector('.pax-infinite-next');
    const sentinel = pagination.querySelector('[data-pax-infinite-sentinel]');
    const status = pagination.querySelector('[data-pax-infinite-status]');
    if (!nextLink || !sentinel || !('fetch' in window) || !('IntersectionObserver' in window)) return;

    document.documentElement.classList.add('pax-infinite-ready');
    let loading = false;
    let finished = false;

    const fail = () => {
      loading = false;
      document.documentElement.classList.remove('pax-infinite-loading', 'pax-infinite-ready');
      if (status) status.textContent = 'Automatisk laddning misslyckades. Använd knappen för att ladda fler produkter.';
      observer.disconnect();
    };

    const loadNext = async () => {
      if (loading || finished || !nextLink.href) return;
      loading = true;
      document.documentElement.classList.add('pax-infinite-loading');
      if (status) status.textContent = 'Laddar fler produkter…';

      try {
        const response = await fetch(nextLink.href, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error('HTTP ' + response.status);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = doc.querySelector('.pax-collection-product-grid');
        if (!nextGrid) throw new Error('Produktgrid saknas');

        const cards = Array.from(nextGrid.children);
        cards.forEach((card) => grid.appendChild(card));
        document.dispatchEvent(new CustomEvent('pax:products-appended', { detail: { count: cards.length } }));

        const nextPagination = doc.querySelector('[data-pax-infinite-pagination]');
        const followingLink = nextPagination && nextPagination.querySelector('.pax-infinite-next');

        if (followingLink && followingLink.href) {
          nextLink.href = followingLink.href;
          if (status) status.textContent = cards.length + ' fler produkter laddades.';
        } else {
          finished = true;
          observer.disconnect();
          pagination.remove();
        }
      } catch (error) {
        console.error('PAX infinite scroll:', error);
        fail();
        return;
      } finally {
        loading = false;
        document.documentElement.classList.remove('pax-infinite-loading');
      }
    };

    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) loadNext();
    }, { rootMargin: '900px 0px' });

    observer.observe(sentinel);

    nextLink.addEventListener('click', (event) => {
      if (!document.documentElement.classList.contains('pax-infinite-ready')) return;
      event.preventDefault();
      loadNext();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
